import React from 'react';
import {
    Popover,
    Icon,
    ButtonDropdown
} from '@amzn/awsui-components-react/polaris';
import CONSTANTS from 'src/utils/constants';
import {MultiAllocationDataSourceRecord} from "src/models/multidimensional-allocation/MultiAllocationDataSourceRecord";
import {
    MULTI_ALLOCATION_DATA_SOURCE_ACTIONS
} from "src/services/multidimensional-allocation/data-sources/MultidimensionalAllocationDataSourcesReducer";

export enum RowActions {
    EDIT,
    DUPLICATE,
    REMOVE,
    REFRESH_BALANCE_PULL,
}

export function ErrorPopover(props: {error: string|Map<string, string>}) {
    const { error } = props;

    const getErrorKeyDisplay = (errorKey: string) => {
        const fieldObj = Object.values(CONSTANTS.DATA_SOURCE_FIELDS).find((x) => x.ACCESSOR == errorKey);
        if (fieldObj != null) {
            return (fieldObj as any)['DISPLAY'] || errorKey;
        } else {
            return errorKey;
        }
    }

    const getErrorDisplay = (errorValue: string | undefined) => {
        if (errorValue == null) {
            return '';
        }
        const errorValArray = errorValue.split(':');
        return errorValArray.length > 0 ? errorValArray[0] : '';
    }

    return (
        <div className="stepErrorContainer">
            <Popover
                className="errorMessagePopover"
                dismissButton={false}
                position="top"
                size="small"
                triggerType="custom"
                content={
                    typeof error === 'string' ? error :
                        <ul>
                            {Array.from(error.keys()).map((x) => <li key={x}>{getErrorKeyDisplay(x)}: {getErrorDisplay(error.get(x))}</li>)}
                        </ul>
                }
            >
                <Icon
                    name="status-warning"
                    size="small"
                    variant="warning"
                />
            </Popover>
        </div>
    )
}

export function RowContextMenu(props: {row: any, allowEditActions: boolean, dispatch: any, recordBeingEdited: MultiAllocationDataSourceRecord | undefined, isViewingHistoricalData?: boolean}) {
    const { row, dispatch, recordBeingEdited, allowEditActions, isViewingHistoricalData = false } = props;

    const menuItems = row.isEditing?
        [{ text: "Remove", id: String(RowActions.REMOVE) }]
        :
        (
            allowEditActions && !isViewingHistoricalData?
                [
                    { text: "Edit", id: String(RowActions.EDIT) },
                    { text: "Duplicate", id: String(RowActions.DUPLICATE) },
                    { text: "Remove", id: String(RowActions.REMOVE) },
                    { text: "Refresh", id: String(RowActions.REFRESH_BALANCE_PULL) }
                ] : [
                    { text: "Refresh", id: String(RowActions.REFRESH_BALANCE_PULL) }
                ]
        );
    return (
        <ButtonDropdown
            className={"rowContextMenu dataSourceRowAction" + row.datasourceId}
            items={menuItems}
            onItemClick={({detail}) => {performRowAction(dispatch, recordBeingEdited, row.datasourceId, detail.id); }}
        >
        </ButtonDropdown>
    )
}

export const performRowAction = (dispatch: any, recordBeingEdited: MultiAllocationDataSourceRecord | undefined, dataSourceId: string, action: string) => {
    dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.SET_RECORD_ID_FOR_ACTION.withPayload(dataSourceId));
    switch (Number(action)) {
        case RowActions.EDIT: {
            if (recordBeingEdited != null && recordBeingEdited.isEditing) {
                if (recordBeingEdited.datasourceId !== dataSourceId) {
                    dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.SHOW_EDIT_CONFIRM_MODAL);
                } else {
                    return;
                }
            } else {
                editRecord(dispatch, recordBeingEdited);
            }
            break;
        }
        case RowActions.REMOVE: {
            dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.SHOW_DELETE_CONFIRM_MODAL);
            break;
        }
        case RowActions.DUPLICATE: {
            if (recordBeingEdited != undefined && recordBeingEdited.isEditing) {
                dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.SHOW_DUPLICATE_CONFIRM_MODAL);
            } else {
                duplicateRecord(dispatch, recordBeingEdited);
            }
            break;
        }
        case RowActions.REFRESH_BALANCE_PULL: {
            dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.REFRESH_BALANCE_STATUS.withPayload(dataSourceId));
            break;
        }
    }
}

export const editRecord = (dispatch: any, recordBeingEdited: MultiAllocationDataSourceRecord | undefined) => {
    if (recordBeingEdited != undefined && recordBeingEdited.isEditing) {
        dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.CANCEL_EDITING);
    }
    dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.EDIT_RECORD);
}

export const duplicateRecord = (dispatch: any, recordBeingEdited: MultiAllocationDataSourceRecord | undefined) => {
    if (recordBeingEdited != undefined && recordBeingEdited.isEditing) {
        dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.CANCEL_EDITING);
    }
    dispatch(MULTI_ALLOCATION_DATA_SOURCE_ACTIONS.DUPLICATE_RECORD);
}
